/* eslint-disable no-unused-vars */

import React, { memo, useMemo } from 'react';
import _ from 'lodash';

import ProximityFilter from './proximity';
import CollapseableTree from '@components/collapseable-tree';
import CollapseableFilter from './task-status';
import Divider from '@components/divider';

import style from './style.module.scss';

const SiteFilterGroup = ({
  coordinates,
  filters,
  unit,
  updateFilters,
  isActive,
  treeData,
  areaHierarchyTreeDataMap,
  siteTypeTags,
  picklistsMap,
  siteStatusTags,
  equipmentListing = false,
  siteListing = false,
  structuredListing = false,
  tasksListing = false,
  filterType = null
}) => {
  return (
    <>
      <div className={style.filterHeader}>
        <p>SITES</p>
      </div>

      <section>
        {coordinates && filterType !== 'workRequest' && (
          <>
            <div className={style.filterRowContainer}>
              <div>
                <ProximityFilter
                  titleText={
                    filters?.proximity?.value > 0
                      ? `Under ${filters?.proximity?.value || 0} ${unit || 'km'}`
                      : ''
                  }
                  value={filters.proximity.value}
                  onChange={(value) => updateFilters('proximity', 'value', value)}
                  max={500}
                  unit={unit || 'km'}
                />
              </div>
            </div>
            <Divider />
          </>
        )}
        <div>
          {!_.isEmpty(areaHierarchyTreeDataMap) && (
            <>
              <div className={style.filterRowContainer}>
                <CollapseableTree
                  header={'Area'}
                  isActive={isActive}
                  treeData={treeData}
                  value={filters?.area?.value}
                  treeDataMap={areaHierarchyTreeDataMap}
                  onChange={(value) => {
                    updateFilters('area', 'value', value);
                  }}
                />
              </div>
              <Divider />
            </>
          )}
        </div>

        <div>
          {siteTypeTags?.length > 0 && (
            <>
              <div className={style.filterRowContainer}>
                <CollapseableFilter
                  title={'Site type'}
                  tags={siteTypeTags || []}
                  tagsMap={picklistsMap}
                  multi
                  value={filters.siteType.value}
                  onChange={(value) => updateFilters('siteType', 'value', value)}
                />
              </div>
              <Divider />
            </>
          )}
        </div>

        {siteStatusTags?.length > 0 && (
          <>
            <div className={style.filterRowContainer}>
              <CollapseableFilter
                title={'Site status'}
                tags={siteStatusTags || []}
                tagsMap={picklistsMap}
                multi
                value={filters?.siteStatus?.value}
                onChange={(value) => updateFilters('siteStatus', 'value', value)}
              />
            </div>
            <Divider />
          </>
        )}
      </section>
    </>
  );
};

export default memo(SiteFilterGroup);
